import React, { useState, useEffect } from "react";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import "./alert.css";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import * as constantMessages from "../../../constants/constatntMessages";
import {
  logOut,
  setInValidUser,
} from "../../../redux/actions/authActions/authAction";
import LoaderButton from "../../Common/LoaderButton";
import { handleApiError } from "../../../helpers/errorResponseHelper";
import BackButton from "../../Common/Backbutton";
import SmallLoaderButton from "../../Common/SmallLoaderButton";

const Alert = () => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const authData = useSelector((state) => state.auth);
  const location = useLocation();

  const [camefromPreviousPage, setCamefrompreviospage] = useState(
    location.state?.camefromPreviousPage || false
  );


  const navigate = useNavigate();
  const dispatch = useDispatch();
  if (authData.isInValidUser && authData.isInvalidUserChecked) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("rememberMe");
    dispatch(logOut());
    navigate("/login");
  }
  const employeeData = useSelector((state) => state.user);
  useEffect(() => {
    if (employeeData?.userData) {
      if (employeeData.userData.isAdmin === false) {
        navigate("/page-not-found");
      }
    }
  }, [employeeData?.userData]);

  const organizationId = userData?.organizationId;
  const accessToken = localStorage.getItem("accessToken");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingDays, setIsLoadingDays] = useState(false);
  const generateOptions = (maxValue, step) => {
    return Array.from(
      { length: Math.floor(maxValue / step) + 1 },
      (_, i) => i * step
    );
  };
  const hourOptions = Array.from({ length: 24 }, (_, i) => i + 0);

  const minuteOptions = generateOptions(60, 5);
  const chaseUpOptions = Array.from({ length: 30 }, (_, i) => i + 1);

  const [meetingReminders, setMeetingReminders] = useState({
    hours: 0,
    minutes: 0,
  });

  const [chaseUpActions, setChaseUpActions] = useState(0);
  const [savedSettings, setSavedSettings] = useState({});

  useEffect(() => {
    document.title = "Alert: MinutesVault";
    const fetchAlertSettings = async () => {
      try {
        if (!accessToken) {
          console.warn("Access token is missing");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/V1/configuration/viewConfiguration/${organizationId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: accessToken,
            },
          }
        );
        if (response?.data?.data?.isInValidUser) {
          dispatch(setInValidUser(true));
          toast.error(response.data.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        } else {
          dispatch(setInValidUser(false));
        }
        if (response.data && response.data.data) {
          const { mettingReminders, chaseOfAction } = response.data.data;

          setMeetingReminders(mettingReminders);
          setChaseUpActions(chaseOfAction);
          setSavedSettings(response.data.data);
        }
      } catch (error) {
        if (handleApiError(error)) return;
        
      }
    };

    fetchAlertSettings();
  }, [organizationId]);

  const isValidate = () => {
    let isValid = true;
    let errors = {};
    if (meetingReminders.hours == 0 && meetingReminders.minutes == 0) {
      errors.hours = "Time should not be 0 hour 0 minutes";
      isValid = false;
    }

    setErrors(errors);
    return isValid;
  };

  const handleSaveAlert = async (e) => {
    e.preventDefault();

    if (isValidate()) {
      try {
        const minHourLimit = 0;
        const maxHourLimit = 100;
        const minMinuteLimit = 0;
        const maxMinuteLimit = 1000;

        if (
          meetingReminders.hours >= minHourLimit &&
          meetingReminders.hours <= maxHourLimit &&
          meetingReminders.minutes >= minMinuteLimit &&
          meetingReminders.minutes <= maxMinuteLimit
        ) {
          const alertData = {
            organizationId,
            mettingReminders: meetingReminders,
            chaseOfAction: chaseUpActions,
            isAlert: true,
          };
          if (!accessToken) {
            console.warn("Access token is missing");
            return;
          }
          const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/V1/alert/editAlert`,
            { ...alertData, organizationId },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: accessToken,
              },
            }
          );
          if (response?.data?.data?.isInValidUser) {
            dispatch(setInValidUser(true));
          } else {
            dispatch(setInValidUser(false));
          }
          if (response.data.success) {
            toast.success(response.data.message, {
              position: "top-right",
              autoClose: 4000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            setSavedSettings(alertData);
          } else {
            toast.error(response.data.message, {
              position: "top-right",
              autoClose: 4000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
        } else {
          toast.error(
            `Value must be above ${minHourLimit} hour and between ${minMinuteLimit} to ${maxMinuteLimit} minutes`,
            {
              position: "top-right",
              autoClose: 4000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            }
          );
        }
      } catch (error) {
        console.error("Error saving alert settings:", error.message);
      } finally {
        setIsLoading(false);
        setIsLoadingDays(false);
      }
    } else {
      setIsLoading(false);
    }
  };

  const handleMeetingReminders = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await handleSaveAlert(e);
    } catch (error) {
      console.log(error);
      if (handleApiError(error)) return;
      
      setIsLoading(false);
    }
  };

  const handleChaseOfAction = async (e) => {
    e.preventDefault();
    setIsLoadingDays(true);
    try {
      await handleSaveAlert(e);
    } catch (error) {
      console.log(error);
      setIsLoadingDays(false);
    }
  };

  const handleChange = (e) => {
    setErrors({});

    const { name, value } = e.target;
    const intValue = parseInt(value, 10);

    if (intValue < 0) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "Must be a Number greater than 0.",
      }));
    } else {
      if (name === "hours" || name === "minutes") {
        setMeetingReminders((prevMeetingReminders) => ({
          ...prevMeetingReminders,
          [name]: intValue,
        }));
      } else if (name === "chaseUpActions") {
        setChaseUpActions(intValue);
      }

      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    }
  };



  return (
    <div>
      <div className="main-content">
        <div className="meeting-room-page">
          <div className="meeting-header-text line-height-h4 d-flex align-items-center justify-content-between">
            <h4>Alerts</h4>
            
             <BackButton show={camefromPreviousPage} />
          </div>
          <div className="mt-2 table-box">
            <form className="meeting-form">
              <div className="pb-3 alert-box">
                <label className="checkbox-container mb-1 d-flex">
                  Send Meeting Reminders
                </label>
                <div className="d-flex resp-flex-column">
                  <div className="alert-send-time">
                    <p>
                      <select
                        value={meetingReminders.hours}
                        name="hours"
                        onChange={handleChange}
                      >
                        {hourOptions.map((option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                      hour(s)
                    </p>
                  </div>

                  <div className="alert-send-time pe-2">
                    <p>
                      <select
                        value={meetingReminders.minutes}
                        name="minutes"
                        onChange={handleChange}
                      >
                        {minuteOptions.map((option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                      min(s)
                    </p>
                  </div>
                  <div className="d-flex align-items-center">
                    <p>before the meeting starts.</p>
                  </div>
                </div>
                <div className="error-container">
                  {errors.hours && (
                    <p className="error">
                      <span className="error-message">{errors.hours}</span>
                    </p>
                  )}
                  {errors.minutes && (
                    <p className="error">
                      <span className="error-message">{errors.minutes}</span>
                    </p>
                  )}
                </div>
                <div className="mt-3">
                  {isLoading ? (
                    <SmallLoaderButton />
                  ) : (
                    <button
                      className="add-btn send-email Mom-btn"
                      type="button"
                      onClick={handleMeetingReminders}
                      disabled={isLoading}
                    >
                      <p>Save Alert </p>
                    </button>
                  )}
                </div>
              </div>
              <div className="mt-3 alert-box">
                <label className="checkbox-container mb-1 d-flex">
                  Due Actions Reminders before
                </label>

                <div className="d-flex resp-flex-column">
                  <div className="alert-send-time chase-width">
                    <p>
                      <select
                        name="chaseUpActions"
                        value={chaseUpActions}
                        onChange={handleChange}
                      >
                        {chaseUpOptions.map((option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                      days
                    </p>
                  </div>
                </div>

                <div className="error-container">
                  {errors.chaseUpActions && (
                    <p className="error">
                      <span className="error-message">
                        {errors.chaseUpActions}
                      </span>
                    </p>
                  )}
                </div>
                <div className="mt-3">
                  {isLoadingDays ? (
                    <SmallLoaderButton />
                  ) : (
                    <button
                      className="add-btn send-email Mom-btn"
                      type="button"
                      onClick={handleChaseOfAction}
                      disabled={isLoadingDays}
                    >
                      <p>Save Alert</p>
                    </button>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      </div>
  )
}


export default Alert